// Per-session "bag reserved" countdown so it stays consistent across the cart
// page + drawer and survives refreshes (more believable than resetting each load).
const KEY = "auraglow_bag_expiry";
const WINDOW_MS = 10 * 60 * 1000;

export function getReservationSeconds() {
  if (typeof window === "undefined") return 600;
  const now = Date.now();
  let expiry = Number(sessionStorage.getItem(KEY));
  if (!expiry || expiry < now) {
    expiry = now + WINDOW_MS;
    sessionStorage.setItem(KEY, String(expiry));
  }
  return Math.max(0, Math.floor((expiry - now) / 1000));
}

export function fmtClock(secs) {
  const m = String(Math.floor(secs / 60)).padStart(2, "0");
  const s = String(secs % 60).padStart(2, "0");
  return `${m}:${s}`;
}
